const NS = 'FeaturedCoursesTileBlock';
const CLS = 'featuredCoursesTileBlock';

export class FeaturedCoursesTileBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$sliderContainer = this.$element.find(`.${CLS}-sliderContainer`);
		this.$carouselSlider = this.$element.find(`.${CLS}-slider`);
		this.$carouselItems = this.$element.find(`.${CLS}-item`);

		this.$carouselSlider.slick({
			appendArrows: this.$sliderContainer,
			nextArrow: `<button type="button" class="slick-arrow slick-arrow--next"><i class="slick-arrow-icon icon icon--chevron-right"></i></button>`,
			prevArrow: `<button type="button" class="slick-arrow slick-arrow--previous"><i class="slick-arrow-icon icon icon--chevron-left"></i></button>`,
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			mobileFirst: false,
			cssEase: 'ease-in-out',
			useTransform: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						centerPadding: '0',
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 600,
					settings: {
						centerMode: true,
						centerPadding: '0',
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});

		this.carouselArrowButton = this.$element.find(`.slick-arrow`);
		this.$carouselItems.css({ opacity: 1 });

		$(window).resize(_.debounce(() => {
			this.adjustArrowPosition();
			this.adjustArrowVisibility();
		}, 50));
	}

	adjustArrowPosition() {
		let imgContainerHeight = this.$element.find(`.slick-active .${CLS}-item-imgContainer`).height();

		this.carouselArrowButton.each((_index, element) => {
			let $arrow = $(element);
			$arrow.css({
				top: `${((imgContainerHeight / 2) - ($arrow.height() / 2))}px`
			});
		});
	}

	adjustArrowVisibility() {
		let $arrows = this.$element.find(`.slick-arrow`);
		if(!($arrows && $arrows.length > 0)) {
			return;
		}

		let previousArrow = this.$element.find(`.slick-arrow--previous`);
		let nextArrow = this.$element.find(`.slick-arrow--next`);

		previousArrow.css({
			display: Math.floor(previousArrow.offset().left) < 0 ? 'none' : 'block'
		});

		nextArrow.css({
			display: (Math.ceil(nextArrow.offset().left + nextArrow.width()) + 1) >= this.getContainerWidth() ? 'none' : 'block'
		});
	}

	getContainerWidth() {
		return $(window).width();
	}
}
